export const WEIGHTING_BAR_CATEGORY_KEY = 'base' as const;
export const WEIGHTING_BAR_COMPONENT_KEY = 'weightingBar' as const;
